<template>
  <v-container>
    <v-row justify="center">
      <v-col sm="10" md="10">
        <location-list-card />
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import LocationListCard from "@/terminals/components/location-and-terminals/LocationListCard.vue";
</script>
